import React from 'react';
import BaseFilterDropdown from './baseFilterDropdown';

const OrderSkusDropdown = ({
  includedSkus,
  excludedSkus,
  addedSkus = [],
  clearAllFilters,
  resetFilterCheck,
  status,
  setSelectedSkus,
  setFilterIncludedSkus,
  filterIncludedSkus,
  matchOptionFlag,
  setMatchOptionFlag,
  onAddSku,
  onRemoveSku,
  fetchSuggestions
}) => {
  return (
    <BaseFilterDropdown
      title="Order Items"
      subtitle="of these skus"
      persistentMenuKey="orderSkusDropdown"
      includedItems={includedSkus}
      excludedItems={excludedSkus}
      addedItems={addedSkus}
      onRemoveItem={onRemoveSku}
      clearAllFilters={clearAllFilters}
      resetFilterCheck={resetFilterCheck}
      status={status}
      setSelectedItems={setSelectedSkus}
      setFilterIncludedItems={setFilterIncludedSkus}
      filterIncludedItems={filterIncludedSkus}
      matchOptionFlag={matchOptionFlag}
      setMatchOptionFlag={setMatchOptionFlag}
      showMatchOption={true}
      showAddInput={true}
      onAddItem={onAddSku}
      addInputPlaceholder="Add SKU..."
      maxVisibleItems={4}
      testIdPrefix="sku"
      fetchSuggestions={fetchSuggestions}
      maxSuggestions={3}
    />
  );
};

export default OrderSkusDropdown;

